import React from 'react';
import { RendererCssClassName } from '../../consts';
import { useSelectAllTrap } from '../utils/use-select-all-trap';
export default function Doc(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: RendererCssClassName.DOCUMENT
  }, props.children);
}
export function DocWithSelectAllTrap(props) {
  return /*#__PURE__*/React.createElement("div", {
    ref: useSelectAllTrap(),
    className: RendererCssClassName.DOCUMENT
  }, props.children);
}